import type { ProductionHistoryWindow } from "@/features/devices/types";

/**
 * Trecho de frase da janela, JA COM a preposicao e o artigo: "Ao longo
 * {windowSpan}".
 *
 * A concordancia muda com a unidade — "das 24 h" (hora, feminino) mas "dos 7
 * dias" (dia, masculino) — entao a preposicao nao pode ser fixa no JSX com o
 * rotulo interpolado depois. Um `Ao longo das {"7 dias"}` sai "Ao longo das 7
 * dias".
 *
 * Esta tabela mora aqui porque ja errou duas vezes por estar duplicada: os
 * herois de ritmo e producao a corrigiram cada um por sua conta, e o
 * `ChartWidget` — que so passou a alcancar 7d/30d quando ganhou o seletor de
 * periodo — ficou com a versao errada. Uma terceira copia repetiria o ciclo.
 */
export const WINDOW_SPAN: Record<ProductionHistoryWindow, string> = {
  "6h": "das 6 h",
  "12h": "das 12 h",
  "24h": "das 24 h",
  "48h": "das 48 h",
  "7d": "dos 7 dias",
  "30d": "dos 30 dias",
};

/** Trecho de frase para uma janela qualquer, com escape para valor inesperado. */
export function windowSpan(window: string): string {
  return WINDOW_SPAN[window as ProductionHistoryWindow] ?? `de ${window}`;
}
